import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveEntry12 from './IconMoveEntry12';
import IconMoveEntry16 from './IconMoveEntry16';
import IconMoveEntry20 from './IconMoveEntry20';
import IconMoveEntry24 from './IconMoveEntry24';
import IconMoveEntry32 from './IconMoveEntry32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveEntry = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveEntry12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveEntry16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveEntry20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveEntry24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveEntry32 {...props} />}
        </span>
    );
};
IconMoveEntry.displayName = 'FondueIconMoveEntry';

export default memo(IconMoveEntry);
